export const Role = {
  Area: 'Area',
  Tutti: 'Tutti',
  Propri: 'Propri',
  Tabelle: 'Tabelle',
  Grafici: 'Grafici',
  Admin: 'Admin'
}
